<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      modelValue: {
        type: String,
        default: ''
      },
      hint: {
        type: String,
        default: ''
      },
      required: Boolean,
      fieldKey: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      disabled: Boolean
    },
    computed: {
      ...mapGetters([
        'ui',
        'errorRes'
      ]),
      errorMessages () {
        if (this.fieldKey) {
          if (this.fieldKey.match(/\./)) {
            // fieldKeyにドットが含まれる場合は、エラーメッセージの階層を増やす
            const splitKey = this.fieldKey.split('.')
            const nestKey = splitKey[0]
            const fieldKey = splitKey[1]
            if (this.errorRes[nestKey]) {
              return this.translateErrorRes(this.errorRes[nestKey][fieldKey])
            }
          } else {
            return this.translateErrorRes(this.errorRes[this.fieldKey])
          }
        }
        return ''
      }
    },
    watch: {
      'ui.loading' () {
        this.$forceUpdate()
      }
    },
    methods: {
      matchTranslate (value) {
        // ApiTranslateの文字が含まれていたら翻訳する
        if (typeof value === 'string' && value.match(/ApiTranslate/)) {
          return this.$t(value)
        } else {
          return value
        }
      },
      translateErrorRes (errorRes) {
        if (errorRes) {
          if (Array.isArray(errorRes)) {
            return this.matchTranslate(errorRes[0])
          } else {
            return this.matchTranslate(errorRes)
          }
        }
      }
    }
  }
</script>
